import { PinInput } from "@mantine/core";

interface SMSCodeInputProps {
  onChange: (code: string) => void;
}

export const SMSCodeInput = ({ onChange }: SMSCodeInputProps) => {
  return (
    <PinInput
      aria-label="One time code"
      autoFocus
      className="my-2"
      length={6}
      onChange={onChange}
      oneTimeCode
      placeholder=""
      radius="6px"
      size="lg"
      type="number"
    />
  );
};
